import { PaletteMode } from '@mui/material';
import { createContext } from 'react';

type ThemeType = {
	theme: PaletteMode;
	setTheme: (data: PaletteMode) => void;
};

export const ThemeContext = createContext<ThemeType>({
	theme: 'light',
	setTheme: (_: PaletteMode) => {},
});
